<template>
  <div class="page">
    <div v-if="!user" class="h-100 d-flex justify-center align-center">
      <v-progress-circular :size="50" color="primary" indeterminate/>
    </div>

    <template v-else-if="user.user_type === CANDIDATE">
      <ProfileCandidate :userId="user.id" />
    </template>

    <template v-else-if="user.user_type === CORPCLIENT">
      <CorpExpiredPage v-if="isCorpExpired" />
      <ProfileClient v-else :userId="user.id" />
    </template>

    <template v-else-if="user.user_type === PARTNER">
      <ProfilePartner :userId="user.id" />
    </template>

    <template v-else-if="user.user_type === MANAGER">
      <ManagerProfile :userId="user.id" />
    </template>

    <template v-else-if="user.user_type === ADMIN">
      <ProfileAdmin :userId="user.id" />
    </template>

    <!-- <div v-if="selectedTab && user.user_type === CANDIDATE" class="profile-board mt-8 pt-2">
      <ProfileTabs />
      <component v-bind:is="selectedTab.component" />
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
 ADMIN, CANDIDATE, CORPCLIENT, MANAGER, PARTNER
} from '@/common/constants/userTypes';
import ProfileCandidate from '@/components/candidates/profile/ProfileCandidate';
import ProfileClient from '@/components/clients/profile/ProfileClient';
import CorpExpiredPage from '@/components/clients/profile/CorpExpiredPage.vue';
import ProfilePartner from '@/components/partners/profile/ProfilePartner';
import ManagerProfile from '@/components/managers/profile/ManagerProfile.vue';
import ProfileAdmin from '@/components/admins/profile/ProfileAdmin';

export default {
  name: 'Profile',
  components: {
    ProfileCandidate, ProfileClient, ProfilePartner, ManagerProfile, ProfileAdmin, CorpExpiredPage
  },
  provide: {
    isProfile: true,
  },
  data: () => ({
    CANDIDATE, CORPCLIENT, PARTNER, MANAGER, ADMIN
  }),
  computed: {
    ...mapGetters({
      selectedTab: 'profile/tabs/selectedTab',
      user: 'auth/user',
      isCorpExpired: 'auth/isCorpExpired',
    }),
  },
  methods: {
    ...mapMutations({
      setCandidateResults: 'users/candidate/loadCandidateResultsSuccess',
    }),
    ...mapActions({
      resetStateCandidate: 'users/candidate/resetState',
      resetStateTabs: 'profile/tabs/resetState',
      getStockBalances: 'users/counters/getStockBalance',
    }),
   async getStockBalance() {
     if (this.user.user_type && this.user.id) {
        const response = await this.getStockBalances({ toType: this.user?.user_type, toId: this.user?.id });
        return response;
     }
   }
  },
  created() {
    // Свои результаты кандидат берёт из get-me: ручка /users/candidates/{id}/get-test-result/ ему закрыта (404)
    if (this.user?.user_type === CANDIDATE) {
      this.setCandidateResults(this.user.tests_results || {});
    }
  },
 async mounted() {
    if (this.user.user_type && this.user.id) {
    await this.getStockBalance();
    }
  },
  beforeDestroy() {
    this.resetStateCandidate();
    this.resetStateTabs();
  },
};
</script>
